(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haomaison-routine"] && !Shopify.designMode) return;
  try {
    
  const routineSections = document.querySelectorAll('[data-haomaison-routine]');

  routineSections.forEach((section) => {
    const track = section.querySelector('[data-routine-track]');
    const previous = section.querySelector('[data-routine-prev]');
    const next = section.querySelector('[data-routine-next]');

    if (!track || !previous || !next) return;

    const scrollBySlide = (direction) => {
      const slide = track.querySelector('.haomaison-routine__slide');
      if (!slide) return;

      const gap = 18;
      track.scrollBy({
        left: direction * (slide.getBoundingClientRect().width + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    previous.addEventListener('click', () => scrollBySlide(-1));
    next.addEventListener('click', () => scrollBySlide(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
